/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_NetrealitInputs */

const cs_enum_netrealit = /** @type {(inputs: Enum_NetrealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netrealit`)
};

const en_enum_netrealit = /** @type {(inputs: Enum_NetrealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netrealit`)
};

/**
* | output |
* | --- |
* | "Netrealit" |
*
* @param {Enum_NetrealitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_netrealit = /** @type {((inputs?: Enum_NetrealitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_NetrealitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_netrealit(inputs)
	return cs_enum_netrealit(inputs)
});